// extracted by mini-css-extract-plugin
module.exports = {"error_wrapper":"styles_error_wrapper__16C7g","text_content":"styles_text_content__2jVvt"};